import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { LedgerHeader } from "../../../../utility/TableHeaders";
import { CustomFilter } from "../../../components/CustomFilter";
import CustomTable from "../../../components/customTable/CustomTable";
import TopHeaderComponent from "../../../components/TopHeaderComponent";
import { SUCCESS } from "../../../resources/constantsManager";
import { saveAs } from "file-saver";

const Ledger = ({ filterOpened }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [openFilter, setOpenFilter] = useState(false);
  const [dateRange, setDateRange] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [data, setData] = useState("");
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [offset, setOffset] = useState(0);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isTableDataError, setIsTableDataError] = useState(false);

  const Filterdata = [
    {
      title: "Search by Date Range",
      type: "dateRange",
      validator: "text",
      placeholder: "Search by Date Range",
      key: "searchByDateRange",
      value: dateRange,
    },
    {
      title: "Search by UTR",
      type: "select",
      placeholder: "Transaction Type",
      key: "searchByTransactionType",
      value: transactionType,
      options: [
        {
          value: "All",
          label: "Transaction Type",
        },
        {
          value: "credit",
          label: "Credit",
        },
        {
          value: "debit",
          label: "Debit",
        },
      ],
    },
    {
      title: "Search By Van",
      type: "input",
      validator: "commonSearch",
      placeholder: "Search by Transaction Id",
      key: "searchByTransactionId",
      value: transactionId,
    },
  ];

  const getAllFilters = (data) => {
    let type = data[1].value?.trim();
    setDateRange(data[0].value?.trim());
    setTransactionType(type === "All" ? "" : type);
    setTransactionId(data[2].value?.trim());
    getLedgerHistory(
      0,
      10,
      data[0].value?.trim(),
      type === "All" ? "" : type,
      data[2].value?.trim()
    );
    setOffset(0);
    setIsFilterApplied(!isFilterApplied);
  };

  const getLedgerHistory = (
    page,
    size,
    dateRange,
    transactionType,
    transactionId
  ) => {
    ApiRequestPost.vanLedgerHistory(
      page,
      size,
      dateRange,
      transactionType,
      transactionId
    )
      .then((res) => {
        if (res.status === SUCCESS) {
          setData(res.data.content);
          setTotalElements(res.data.totalElements);
          setTotalPages(res.data.totalPages);
          setIsTableDataError(false);
        } else {
          setIsTableDataError(true);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsTableDataError(true);
      });
  };

  const oncClickDownloaded = (
    page,
    size,
    dateRange,
    transactionType,
    transactionId
  ) => {
    ApiRequestGet.downloadLedgerTransaction(
      page,
      size,
      dateRange,
      transactionType,
      transactionId
    )
      .then((res) => {
        // if (res.status === SUCCESS) {
        //   enqueueSnackbar(res.message, {
        //     variant: "success",
        //   });
        // } else {
        //   enqueueSnackbar(res.message, {
        //     variant: "error",
        //   });
        // }

        enqueueSnackbar("downloaded successfully", {
          variant: "success",
        });
        saveAs(res, "ledger.csv");
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };
  useEffect(() => {
    getLedgerHistory(0, 10);
  }, []);

  return (
    <div
      style={{
        height: "100%",
        position: "static",
      }}
    >
      <TopHeaderComponent
        buttonRequired
        headerName="Ledger"
        onClickFilter={() => {
          setOpenFilter(!openFilter);
          filterOpened(!openFilter);
        }}
        onClickDownload={() => {
          oncClickDownloaded(
            0,
            totalElements,
            dateRange,
            transactionType,
            transactionId
          );
        }}
        disableDownloadIcon={data?.length === 0}
      />

      <div
        style={{
          width: "100%",
          borderRadius: "15px",
          display: "flex",
          alignItems: "center",
          opacity: openFilter ? 1 : 0,
          marginTop: !openFilter ? "0px" : "20px",
          transition: "all 0.5s ease-in-out",
          backgroundColor: "white",
        }}
      >
        <CustomFilter
          show={openFilter}
          data={Filterdata}
          search={(data) => {
            getAllFilters(data);
          }}
          onClickClear={() => {
            setDateRange("");
            setTransactionType("");
            setTransactionId("");
            getLedgerHistory(0, 10, "", "", "");
          }}
          passActiveFilters={() => {}}
          showClearIcon={true}
        />
      </div>

      <div
        style={{
          marginTop: "20px",
        }}
      >
        <CustomTable
          offset={offset}
          headers={LedgerHeader}
          data={data}
          totalElements={totalElements}
          totalPages={totalPages}
          onClickViewLedgerDetails={() => {}}
          handlePaginate={(page) => {
            setOffset(page);
            getLedgerHistory(
              page,
              10,
              dateRange,
              transactionType,
              transactionId
            );
          }}
          isFilterApplied={openFilter}
          isTableDataError={isTableDataError}
        />
      </div>
    </div>
  );
};

export default Ledger;
